import React from 'react';
import { Box } from '@mui/material';

const SmallFileUploaderLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        marginTop: '0 !important',
        '& .dropdown__multi-value': {
          backgroundColor: 'primary.main',
          color: 'common.white',
          '&__label': {
            color: 'common.white',
          },
        },
        '& .upload-block': {
          display: 'initial',
          '& > .photo-upload': {
            width: 'initial',
          },
        },
      }}
    >
      {children}
    </Box>
  );
};

export default SmallFileUploaderLayout;
